import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var CheckXIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M17.88 12.194a1 1 0 1 1 1.414 1.414l-2.378 2.379 2.57 2.57a1 1 0 0 1-1.414 1.414l-2.571-2.57-2.57 2.57a1 1 0 1 1-1.415-1.414l2.57-2.57-2.378-2.379a1 1 0 0 1 1.414-1.414l2.379 2.379 2.379-2.38ZM11.752 3.836a1 1 0 0 1 1.496 1.329l-5.333 6a1.002 1.002 0 0 1-1.495 0l-2.667-3a1 1 0 0 1 1.495-1.33l1.919 2.16 4.585-5.16Z",
    fill: props.fill || "currentColor"
  }
) }));

export { CheckXIcon };
